<template>
  <v-dialog :value="value" max-width="420" @input="$emit('input', $event)">
    <div class="modal">
      <h3>{{ isEdit ? 'Изменить зону' : 'Новая зона' }}</h3>

      <label class="mlabel">Название зоны</label>
      <!-- авторост от 1 до 6 строк по содержимому, дальше прокрутка (autoGrow) -->
      <textarea
        ref="nameField"
        v-model="localName"
        class="mfield mfield-area"
        rows="1"
        @input="autoGrow()"
      />

      <label class="mlabel" style="margin-top: 16px">Цвет зоны</label>
      <div class="crow">
        <button
          v-for="c in order"
          :key="c"
          type="button"
          class="crb"
          :style="localColor === c ? { borderColor: colors[c] } : {}"
          @click="localColor = c"
        >
          <span class="dot" :style="{ background: colors[c] }" />{{ names[c] }}
        </button>
      </div>

      <!-- подтверждение удаления прямо в окне: зона уходит из списка и с карты сразу,
           DELETE на бек — только по общей кнопке «Сохранить» -->
      <div v-if="confirmingDelete" class="mdelete">
        <p class="mdelete-text">
          Удалить зону? Она исчезнет с карты, на сервере удалится после кнопки «Сохранить».
        </p>
        <div class="mactions">
          <button type="button" class="btn-cancel" @click="confirmingDelete = false">
            Назад
          </button>
          <button type="button" class="btn-delete" @click="$emit('delete', zone.id)">
            Удалить
          </button>
        </div>
      </div>
      <div v-else class="mactions">
        <button type="button" class="btn-cancel" @click="$emit('input', false)">
          Отмена
        </button>
        <button
          type="button"
          class="btn-apply"
          :disabled="!cleanName"
          @click="apply"
        >
          Применить
        </button>
      </div>
      <button
        v-if="isEdit && !confirmingDelete"
        type="button"
        class="btn-delete-link"
        @click="confirmingDelete = true"
      >
        <v-icon small color="#ed4543">
          mdi-trash-can-outline
        </v-icon>
        Удалить зону
      </button>
    </div>
  </v-dialog>
</template>

<script>
  import { ZONE_COLORS, ZONE_NAMES, ZONE_ORDER } from '@/constants/deliveryZones'

  export default {
    name: 'ZoneDialog',
    props: {
      value: { type: Boolean, default: false },
      zone: { type: Object, default: null },
    },
    data () {
      return {
        colors: ZONE_COLORS,
        names: ZONE_NAMES,
        order: ZONE_ORDER,
        localName: '',
        localColor: 'green',
        confirmingDelete: false,
      }
    },
    computed: {
      isEdit () {
        return !!(this.zone && this.zone.id)
      },
      // textarea: переводы строк и двойные пробелы в имени не нужны
      cleanName () {
        return this.localName.replace(/\s+/g, ' ').trim()
      },
    },
    watch: {
      value (open) {
        if (open) {
          this.localName = this.zone ? this.zone.name : ''
          this.localColor = this.zone ? this.zone.color : 'green'
          this.confirmingDelete = false
          // содержимое диалога рендерится лениво — высоту считаем после отрисовки
          this.$nextTick(this.autoGrow)
        }
      },
      localName () {
        this.$nextTick(this.autoGrow)
      },
    },
    methods: {
      // высота textarea по тексту: минимум 1 строка, максимум 6, дальше прокрутка
      autoGrow (tries = 0) {
        const el = this.$refs.nameField
        if (!el) return
        // при первом открытии v-dialog поле ещё не показано: scrollHeight = 0,
        // ждём кадр отрисовки (не больше ~10 кадров), пока оставляем естественную высоту
        if (!el.offsetParent) {
          el.style.height = ''
          if (tries < 10) requestAnimationFrame(() => this.autoGrow(tries + 1))
          return
        }
        const cs = getComputedStyle(el)
        const frame =
          parseFloat(cs.paddingTop) +
          parseFloat(cs.paddingBottom) +
          parseFloat(cs.borderTopWidth) +
          parseFloat(cs.borderBottomWidth)
        const max = parseFloat(cs.lineHeight) * 6 + frame
        el.style.height = 'auto'
        const need = el.scrollHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth)
        el.style.height = Math.min(need, max) + 'px'
        el.style.overflowY = need > max ? 'auto' : 'hidden'
      },
      apply () {
        if (!this.cleanName) return
        this.$emit('apply', { name: this.cleanName, color: this.localColor })
      },
    },
  }
</script>

<style scoped>
  .modal {
    background: #fff;
    border-radius: 14px;
    padding: 24px;
  }
  .modal h3 {
    margin: 0 0 16px;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }
  .mlabel {
    display: block;
    font-size: 13px;
    color: #6b7178;
    margin-bottom: 6px;
  }
  .mfield {
    width: 100%;
    height: 42px;
    border: 1px solid #e0e3e7;
    border-radius: 8px;
    padding: 0 12px;
    outline: none;
  }
  .mfield:focus {
    border-color: #ff9100;
    box-shadow: 0 0 0 3px rgba(255, 145, 1, 0.26);
  }
  .mfield-area {
    display: block;
    height: auto;
    padding: 10px 12px;
    line-height: 1.35;
    resize: none;
    overflow-y: hidden;
    font: inherit;
  }
  .mdelete-text {
    margin: 20px 0 0;
    font-size: 13px;
    color: #6b7178;
    text-align: center;
  }
  .btn-delete {
    flex: 1;
    height: 44px;
    border: 0;
    background: #ed4543;
    color: #fff;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    cursor: pointer;
  }
  .btn-delete-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    margin-top: 14px;
    height: 36px;
    border: 0;
    background: transparent;
    color: #ed4543;
    font-size: 13px;
    cursor: pointer;
    border-radius: 8px;
  }
  .btn-delete-link:hover {
    background: #fdecea;
  }
  .crow {
    display: flex;
    gap: 8px;
  }
  .crb {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    background: #f7f8f9;
    border: 2px solid #e0e3e7;
    border-radius: 10px;
    height: 44px;
    cursor: pointer;
  }
  .crb .dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
  .mactions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }
  .btn-cancel {
    flex: 1;
    height: 44px;
    border: 1px solid #e0e3e7;
    background: #fff;
    border-radius: 8px;
    cursor: pointer;
  }
  .btn-apply {
    flex: 1;
    height: 44px;
    border: 0;
    background: #ff9100;
    color: #fff;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    cursor: pointer;
  }
  .btn-apply:disabled {
    opacity: 0.6;
    cursor: default;
  }
</style>
